import { Router } from '@angular/router';
import { Auth } from './auth.service';
var RoleGuard = /** @class */ (function () {
    function RoleGuard(auth, router) {
        this.auth = auth;
        this.router = router;
    }
    RoleGuard.prototype.canActivate = function (route) {
        if (!this.auth.isLoggedIn()) {
            var next = this.router['location'].path();
            this.router.navigate(['/belepes'], { queryParams: { n: next } });
            return false;
        }
        if (!(_a = this.auth).hasAnyRoleOf.apply(_a, (route.data['allowed'] || []))) {
            var next = this.router['location'].path();
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate(['/jogosulatlan'], { queryParams: { n: next } });
            return false;
        }
        return true;
        var _a;
    };
    return RoleGuard;
}());
export { RoleGuard };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/auth/role-guard.service.ts.pre-build-optimizer.js